// ===== Top Nav Renderer =====
// menuConfig 기반 데스크톱 상단 네비 그룹 드롭다운 렌더링 (navArea === "top" 항목)

const TopNavRenderer = (() => {
  type CoreTopNavGroupId = "today" | "collect" | "records" | "work" | "automation" | "shortcuts";
  const GROUP_LABELS: Record<CoreTopNavGroupId, string> = {
    today: "오늘",
    collect: "수집",
    records: "기록",
    work: "업무",
    automation: "자동화",
    shortcuts: "바로가기",
  };

  let _openGroupId: string | null = null;

  function _getGroupLabel(groupId: string): string {
    return groupId in GROUP_LABELS ? GROUP_LABELS[groupId as CoreTopNavGroupId] : groupId;
  }

  function _closeAll() {
    if (!_openGroupId) return;
    _openGroupId = null;
    document.querySelectorAll(".top-nav-group.open").forEach((el) => el.classList.remove("open"));
  }

  function _toggleGroup(groupId: string): void {
    const wasOpen = _openGroupId === groupId;
    _closeAll();
    if (wasOpen) return;
    const group = document.querySelector(`.top-nav-group[data-group-id="${groupId}"]`);
    if (!group) return;
    group.classList.add("open");
    _openGroupId = groupId;
  }

  /** 드롭다운 항목(<a data-view>) 생성 — 클릭 시 기존 [data-view] 위임이 라우팅을 처리 */
  function _createDropdownItem(item: CoreMenuItem): HTMLAnchorElement {
    const a = document.createElement("a");
    a.className = "top-nav-dropdown-item";
    a.href = "#";
    a.dataset.view = item.id;
    a.innerHTML = `${getMenuIcon(item, 16)}<span>${item.label}</span>`;
    a.addEventListener("click", () => _closeAll());
    return a;
  }

  function _createGroup(groupId: string, items: CoreMenuItem[]): HTMLDivElement {
    const group = document.createElement("div");
    group.className = "top-nav-group";
    group.dataset.groupId = groupId;

    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "top-nav-group-toggle";
    toggle.innerHTML = `<span>${_getGroupLabel(groupId)}</span><svg class="top-nav-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>`;
    toggle.addEventListener("click", (e) => {
      e.stopPropagation();
      _toggleGroup(groupId);
    });

    const dropdown = document.createElement("div");
    dropdown.className = "top-nav-dropdown";
    items.forEach((item) => dropdown.appendChild(_createDropdownItem(item)));

    group.appendChild(toggle);
    group.appendChild(dropdown);
    return group;
  }

  /** 상단 네비 전체 렌더링 */
  function render() {
    const nav = document.querySelector(".top-nav");
    if (!nav) return;
    nav.innerHTML = "";
    _closeAll();
    getTopNavGroupedItems().forEach(({ groupId, items }) => {
      nav.appendChild(_createGroup(groupId, items));
    });
    _renderShortcuts();
    if (typeof router !== "undefined") syncActive(router._activeNavId || router.currentView);
  }

  // Refresh only the dynamic group: the work-count feature owns badges in the static groups.
  function _renderShortcuts(): void {
    const nav = document.querySelector(".top-nav");
    if (!nav) return;
    if (_openGroupId === "shortcuts") _closeAll();
    nav.querySelector('.top-nav-group[data-group-id="shortcuts"]')?.remove();
    if (typeof MenuShortcuts !== "undefined") {
      const shortcuts = MenuShortcuts.getShortcuts();
      if (shortcuts.length) {
        const group = _createGroup("shortcuts", []);
        const dropdown = group.querySelector(".top-nav-dropdown");
        shortcuts.forEach((item) => dropdown?.appendChild(MenuShortcuts.createLink(item,
          "top-nav-dropdown-item top-nav-shortcut-item", _closeAll)));
        nav.appendChild(group);
      }
    }
  }

  /** active 클래스 동기화 (router._updateNav 연동) */
  function syncActive(navId: string): void {
    document.querySelectorAll<HTMLElement>(".top-nav-dropdown-item").forEach((el) => {
      el.classList.toggle("active", el.dataset.view === navId);
    });
    document.querySelectorAll(".top-nav-group").forEach((group) => {
      const hasActive = !!group.querySelector(".top-nav-dropdown-item.active");
      group.classList.toggle("has-active", hasActive);
    });
  }

  // 외부 클릭 시 닫힘
  document.addEventListener("click", (e) => {
    if (!_openGroupId) return;
    if (e.target instanceof Element && e.target.closest(".top-nav-group")) return;
    _closeAll();
  });

  // ESC 키로 닫힘
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && _openGroupId) _closeAll();
  });

  function init() {
    render();
    if (typeof window !== "undefined") window.addEventListener("menu-shortcuts-changed", _renderShortcuts);
  }

  return { init, render, syncActive };
})();
